import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Box } from '@material-ui/core';
import PF2MButton from '~/components/PF2MButton';
import NotificationDropdown from './NotificationDropdown';

const groupByType = notifications => notifications.reduce((acc, notif) => {
  acc[notif.type] = acc[notif.type] || [];
  acc[notif.type].push(notif);
  return acc;
}, { Chat: [], Dispatch: [] });

export default function NotificationTabs({ notifications, markAsRead, markAsAllRead }) {
  const { t: translate } = useTranslation();
  const [tab, setTab] = useState(0);
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  const [filterStates, setFilterStates] = useState(
    Object.keys(groupByType(notifications)).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {}),
  );

  const grouped = groupByType(notifications);
  const types = Object.keys(grouped);

  const filtered = filterStates[types[tab]]
    ? grouped[types[tab]]?.filter(n => !n.read)
    : grouped[types[tab]] || [];

  const handleChange = (_, newValue) => {
    setTab(newValue);
    setShowUnreadOnly(!showUnreadOnly);
  };

  const handleMarkAsAllRead = (curTab) => {
    const currentTabDataNotifications = grouped[types[curTab]]?.filter(
      n => !n.read,
    ).map(notif => notif.id);
    markAsAllRead(currentTabDataNotifications);
  };

  const handleShowUnreadOnly = (curTab) => {
    setFilterStates(prev => ({
      ...prev,
      [Object.keys(filterStates)[curTab]]: !filterStates[Object.keys(filterStates)[curTab]],
    }));
  };

  return (
    <>
      {types.length > 1 && (
        <Tabs
          value={tab}
          onChange={handleChange}
          variant="fullWidth"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
        >
          {types.map(type => (
            <Tab key={type} label={`${translate(`common:${type}`)} (${grouped[type].filter(n => !n.read).length})`} />
          ))}
        </Tabs>
      )}
      <Box display="flex" justifyContent="space-between" p={1}>

        <PF2MButton
          onClick={() => handleShowUnreadOnly(tab)}
          style={{
            color: filterStates[Object.keys(filterStates)[tab]] ? '#FFFFFF' : 'grey',
            backgroundColor: filterStates[Object.keys(filterStates)[tab]] ? '#FFC300' : '#FFFFFF',
          }}
        >
          {'Exibir apenas não lidas'}
        </PF2MButton>

        <PF2MButton
          onClick={() => (handleMarkAsAllRead(tab))}
          style={{
            color: 'grey',
            backgroundColor: '#FFFFFF',
          }}
        >
          {'Marcar todas como lidas'}
        </PF2MButton>
      </Box>
      <Box p={1}>
        <NotificationDropdown
          notifications={filtered || []}
          markAsRead={markAsRead}
        />
      </Box>
    </>
  );
}
